// "Message an agent": a quiet list of idle and finished agents. Sending is off in v0.1, with the
// honest reason (SPEC 5.5: herdr has no conditional send yet), so the list is shown but disabled.
import { useAppState } from "../app/AppContext";
import { Banner } from "../components/Banner";
import { Page, TabBar, TopBar } from "../components/Shell";
import { agentVisual, stateIcon, STATE_WORD } from "../components/StateChip";
import { kindLabel } from "./Inbox";

export function MessageAgent() {
  const s = useAppState();
  const machine = s.machine?.name ?? s.pairing?.machine.name ?? "your PC";
  const quiet = s.agents.filter((a) => a.status === "idle" || a.status === "done");
  return (
    <>
      <TopBar back="/" title="Inbox" />
      <Page>
        <h2 className="label">Message an agent</h2>
        <Banner icon="info" title="Messages are off for now.">
          A message starts a new turn, so it may only go to an agent that is idle or finished at the moment it's sent. herdr can't yet promise that (it has no "send only if still idle"), so {machine} refuses messages until it can. This list stays here so you can see who's free.
        </Banner>
        {quiet.length === 0 ? (
          <div className="empty">
            <h2>No idle or finished agents.</h2>
            <p>Agents that stop working show up here.</p>
          </div>
        ) : (
          <ul className="rows" aria-label="Idle and finished agents">
            {quiet.map((a) => {
              const v = agentVisual(a.status);
              return (
                <li key={a.id} className="row is-dim" aria-disabled="true">
                  <span className="bar" aria-hidden="true" />
                  <span className="main">
                    <span className="name">
                      <b>{a.name}</b>
                      <span className="kind">{kindLabel(a.kind)}</span>
                    </span>
                    <span className="ctx">{a.project ?? a.env}</span>
                  </span>
                  <span className="side">
                    <span className={`chip chip-${v === "finished" ? "finished" : "idle"}`}>
                      {stateIcon(v)}
                      {STATE_WORD[v]}
                    </span>
                  </span>
                </li>
              );
            })}
          </ul>
        )}
        <button type="button" className="btn btn-ghost btn-block" disabled aria-disabled="true">
          Send a new instruction · waiting on herdr support
        </button>
      </Page>
      <TabBar />
    </>
  );
}
